import { PeoplePageSourceDerivedQuestionSectionAttributes } from 'api/custom-section/types';
import { isEmpty } from 'lodash';
import { PromptInputFormValues } from '../types';

export const attributesToForm = (
  attributes: PeoplePageSourceDerivedQuestionSectionAttributes,
): PromptInputFormValues => {
  const { config } = attributes;

  return {
    title: attributes.title,
    question: config.question,
    aiContextChecked: !isEmpty(config.aiContext),
    aiContext: config.aiContext || '',
    groupBy: config.groupBy,
    generateAs: config.generateAs,
    sourcePageTemplates: config.sourcePageTemplates,
  };
};
